export default function ({state, rootGetters, commit, dispatch}, id) {
    debugger
    if(!id) return;
    let report = state.items.filter(i => {
        return i.WebReportId === id;
    })[0];
    if(!report) return;
    let url = '';
    url = report.Url;
    if(report.NeedSelectedData.length){
        let form = rootGetters['subsidies/item/form/data'];
        report.NeedSelectedData.forEach(k=>{
            switch (k){
                case 'StartDate':
                case 'EndDate':
                case 'IssueDate':
                    url += '&' + encodeURIComponent('parameters[' + k + '.Serialized]') + '=' + encodeURIComponent(form[k].Serialized);
                    break;
                default:
                    url += '&' + encodeURIComponent('parameters[' + k + ']') + '=' + encodeURIComponent(form[k]);
            }
        });
    }
    window.open(url);
    // return url;
    // if (item.NeedScreenFilter) {
    //     url += context.getters.form_data;
    //
    //     return;
    // }
}
